import { FC } from 'react';
import { Typography } from '@mui/material';

export const RooftopHelpContent: FC = () => {
  return (
    <>
      <Typography variant="body1" paragraph>
        Rooftops represent your <strong>business locations</strong> or <strong>dealerships</strong>. They allow you to
        organize job postings by physical location or brand.
      </Typography>

      <Typography variant="body1" paragraph>
        When you post a job, it will be associated with a specific rooftop. Job seekers will see that rooftop's name,
        location, and contact information on the job listing.
      </Typography>

      <Typography variant="body1">
        If you have multiple locations or dealerships, each one should be set up as its own rooftop. Any changes made to
        a rooftop's details will automatically update across all associated job postings.
      </Typography>
    </>
  );
};

export default RooftopHelpContent;
